import {createContext, Dispatch, SetStateAction} from "react";

export enum MobileMenuState {
	CLOSED = 0,
	SORT = 1,
	FILTER = 2,
}

export interface PwaContextInterface {
	mobileMenuState: MobileMenuState;
	setMobileMenuState: Dispatch<SetStateAction<MobileMenuState>>;
}

export const PwaContext = createContext<PwaContextInterface>(
	{} as PwaContextInterface
);
